import React, { useState } from 'react';
import { WdiPageContainer } from '@/components/WdiControls/WdiPageContainer';
import DynamicTarget from '@/components/WdiBus/DynamicTarget';
import FormDiscussions from '@/components/WdiBus/FormDiscussions';

type DynamicInformationProps = {
  formId?: number;
  pageTypeId?: number;
  formTypeId?: number;
  useCaseId?: number;
};
type FlowNodeUser = {
  loginName: string;
  displayName: string;
  id: number;
};
/**动态信息表 */
const DynamicInformation: React.FC<DynamicInformationProps> = (props) => {
  const dynamicProps = {
    objectId: props.formId,
    pageTypeId: props.pageTypeId,
    formTypeId: props.formTypeId,
    useCaseId: props.useCaseId,
  };
  const discussionsProps = {
    objectId: props.formId,
    useCaseId: props.useCaseId,
  };
  const [flowNodeUser, setFlowNodeUser] = useState<FlowNodeUser | undefined>();
  const onChange = (value: FlowNodeUser) => {
    setFlowNodeUser(value);
  };
  return (
    <WdiPageContainer>
      <FormDiscussions dataItem={discussionsProps} flowNodeUser={flowNodeUser} />
      <DynamicTarget dataItem={dynamicProps} onChange={onChange} />
    </WdiPageContainer>
  );
};

export default DynamicInformation;
